// extracted by mini-css-extract-plugin
export default {"ddRows":"Pagination_ddRows__FQhja","ddRows_label":"Pagination_ddRows_label__zrN9x","ddRows_select_option":"Pagination_ddRows_select_option__BG5e7"};